export default function ($el) {
  const $primaryText = $el.html();
  const $secondaryText = $el.data('toggled-text');

  $el.on('click', () => {
    const $container = $($el.data('container'));
    const $parentField = $container.find('#campaign_parent');

    $container.toggleClass('team-toggled');
    $container.find('.team').toggle();
    $container.find('.individual').toggle();
    $el.html($el.html() === $primaryText ? $secondaryText : $primaryText);

    $parentField.val($parentField.val() === 'true' ? 'false' : 'true');
  });

  if (window.checkHash('#team')) {
    $el.trigger('click');
  }
}

window.checkHash = function (string) {
  return window.location.hash === string;
};
